import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#050508]" data-testid="privacy-page">
      <Navbar />

      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl text-white mb-8">Privacy Policy</h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#A1A1AA]">
            <section>
              <h2 className="font-heading text-xl text-white mb-4">1. Information We Collect</h2>
              <p>
                We collect minimal information necessary to provide our services:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Email address (for account creation and communication)</li>
                <li>Username (for identification)</li>
                <li>Payment information (processed securely through Stripe)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">2. How We Use Your Information</h2>
              <p>
                Your information is used to:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Provide and manage your account</li>
                <li>Process transactions</li>
                <li>Deliver purchased products and license keys</li>
                <li>Communicate service updates and support</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">3. Data Security</h2>
              <p>
                We implement industry-standard security measures to protect your data. Passwords are 
                encrypted, and payment processing is handled by Stripe, a PCI-compliant payment processor.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">4. Cryptocurrency Payments</h2>
              <p>
                We accept cryptocurrency payments through Stripe for enhanced privacy. We do not store 
                your wallet addresses or cryptocurrency transaction details beyond what is necessary 
                for order fulfillment.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">5. Third-Party Services</h2>
              <p>
                We use Stripe for payment processing. Their privacy policy governs the handling of 
                payment information. We do not sell or share your personal information with other 
                third parties.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">6. Data Retention</h2>
              <p>
                We retain your account information as long as your account is active. You may request 
                account deletion by contacting us through Discord.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">7. Contact</h2>
              <p>
                For privacy concerns, please contact us through our{" "}
                <a href="https://discord.gg/efeySGKGJk" target="_blank" rel="noopener noreferrer" className="text-[#4F7CFF] hover:underline">
                  Discord server
                </a>.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
